import request from "@/global/request/request";
import API from "@/global/request/api";

const challengeService = {
  challengeTaskList(params) {
    return request.get(API.challengeTasks, params);
  },
  challengeTaskDetail(id) {
    return request.get(API.challengeTaskId(id));
  },
  createMyChallenge(params) {
    return request.post(API.myChallenge, params);
  },
  updateMyChallenge(id, params) {
    return request.put(API.myChallengeId(id), params);
  },
  createMyChallengeAnswer(id, params) {
    return request.post(API.myChallengeIdAnswers(id), params);
  },
  myChallengeList(params) {
    return request.get(API.myChallenge, params);
  },
  myChallengeDetail(id) {
    return request.get(API.myChallengeId(id));
  },
  myChallengeAnswerAll(id) {
    return request.get(API.myChallengeIdAnswerAll(id));
  },
  myChallengeAnswerDetail(id, answerId) {
    return request.get(API.myChallengeIdAnswerId(id, answerId));
  },
  myChallengeAnswerUpdate(id, answerId, params) {
    return request.put(API.myChallengeIdAnswerId(id, answerId), params);
  },
  myChallengeTaskAll() {
    return request.get(API.myChallengeTaskAll);
  },
  myChallengeContentDetail(id) {
    return request.get(API.myChallengeContent(id));
  },
  myChallengeContentUpdate(id, params) {
    return request.put(API.myChallengeContent(id), params);
  },
  myChallengeAudit(id) {
    return request.put(API.myChallengeAudit(id));
  },
  myChallengeAnswerTip(id) {
    return request.get(API.myChallengeAnswerTip(id));
  },
  myChallengeAnswerTipEdit(id, params) {
    return request.put(API.myChallengeAnswerTip(id), params);
  },
  myChallengeEvaluateRequire(id) {
    return request.get(API.myChallengeEvaluateRequire(id));
  },
  myChallengeEvaluateRequireEdit(id, params) {
    return request.put(API.myChallengeEvaluateRequire(id), params);
  },
  myChallengeDuplicateCheck(id) {
    return request.get(API.challengeDuplicateCheck(id));
  },
  myChallengeDuplicateDetail(id, params) {
    return request.get(API.challengeDuplicateDetail(id), params);
  },

  //挑战作品
  challengesWork(params) {
    return request.get(API.challengesWork, params);
  },
  challengesWorkDetail(id) {
    return request.get(API.challengeWorksId(id));
  },
  challengeWorksEvaluate(id, params) {
    return request.put(API.challengeWorksEvaluate(id), params);
  },
  myChallengesWork(params) {
    return request.get(API.myChallengesWork, params);
  },
  challengeWorkGrab(params) {
    return request.put(API.challengeWorkGrab, params);
  },
  challengeWorkRelease(params) {
    return request.put(API.challengeWorkRelease, params);
  },
  challengeAttachment(id, params) {
    return request.put(API.challengeAttachment(id), params);
  }
};

export default challengeService;
